import { CanDeactivate } from "@angular/router";
import { CreateNectaModuleComponent } from "../components/create-necta-module/create-necta-module.component";
import { Observable, Subject } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { ConfirmationService } from "primeng/api";


@Injectable({ providedIn: 'root' })
export class ModuleUploadGuard implements CanDeactivate<CreateNectaModuleComponent> {
  private confirmation = inject(ConfirmationService);

  canDeactivate(component: CreateNectaModuleComponent): boolean | Observable<boolean> {
     const store = component.store;
    if (!store.hasPendingOrUploaded()) return true;

    const decision$ = new Subject<boolean>();

    this.confirmation.confirm({ 
      message: 'Wollen Sie die Änderungen wirklich verwerfen?',
      header: 'Änderungen verwerfen',
      acceptLabel: 'Verwerfen',
      rejectLabel: 'Abbrechen',
      icon: 'pi pi-exclamation-triangle',
      accept: () => { decision$.next(true); decision$.complete(); },   // Navigation erlauben
      reject: () => { decision$.next(false); decision$.complete(); },  // Navigation abbrechen
    });
    decision$.subscribe(async (canLeave) => {
        if (canLeave) await store.resetOnLeave();
    });
    return decision$.asObservable();
  }
}